import { AnnotationIcon } from '@heroicons/react/outline';
import React, { useEffect } from 'react';

function ContactUs() {
  /// Title Specification ///

  useEffect(() => {
    document.title = 'Contact Us - Contact Information for Requests';
  }, []);

  /// HTML Component ///

  return (
    <div className="w-[560px] rounded-lg shadow-lg bg-white font-body mx-auto my-20">
      <div className="p-4">
        <div className="component-icon-container bg-sky-400">
          <AnnotationIcon className="w-8 h-8" />
        </div>
        <p className="text-2xl p-1 m-1">Contact Us</p>
        <div className="mt-3 p-3 text-lg border rounded-lg m-2 hover:bg-slate-300">
          <p className="text-xl mb-1">TPxTAX GmbH</p>
          <p>Anne-Frank-Straße 21e</p>
          <p>22587 Hamburg</p>
          <p>Deutschland</p>
          <br></br>
          <p>
            E-Mail:{' '}
            <a
              className="hover:bg-sky-300 hover:text-white transition"
              href="mailto:info@tpx-tax.com"
            >
              info@tpx-tax.com
            </a>
          </p>
          <p>
            Tel.:{' '}
            <a className="hover:bg-sky-300 hover:text-white transition" href="tel:+4915167106634">
              +49 151 6710 6634
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
